import { STATUS_TYPE } from '../../../enum';

export interface IInitialValue {
  id?: string;
  title: string;
  message: string;
  type: string;
  // locationId?: string;
  language?: string;
}

export interface GetPushNotificationManagement {
  id: string;
}

export interface FindPushNotificationManagement {
  search?: string;
  limit?: number;
  skip?: number;
}

export interface CreatePatchPushNotificationManagement {
  id?: string;
  type: string;
  title?: string;
  message?: string;
  countOnly?: boolean;
  // locationId?: string;
  language?: string;
}

export interface PushNotificationManagement {
  id: string;
  type: string;
  title: string;
  message: string;
  // locationId: string;
  senderUserDetails?: {
    id: string;
    name: string;
    // firstName: string;
    // lastName: string;
  }
  location_management?: {
    id: string;
    labelEn: string;
    labelAr: string;
  }
  language: string;
  createdBy: string;
  updatedBy: string;
  updatedAt: string;
  createdAt: string;
}

interface InitialState {
  data: PushNotificationManagement[];
  count: number;
  skip: number;
  limit: number;
  totalRecords: number;
  currentPage: number;
  status: STATUS_TYPE;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  errorMessage: string;
}

export const initialState: InitialState = {
  data: [],
  count: 0,
  skip: 0,
  limit: 25,
  totalRecords: 0,
  currentPage: 0,
  status: 'idle',
  isError: false,
  isLoading: false,
  isSuccess: false,
  errorMessage: '',
};
